import homeIcon from "./DrawerIcons/home.svg";
import messagingIcon from "./DrawerIcons/messaging.svg";
import inboxIcon from "./DrawerIcons/inbox.svg";
import workflowBuilderIcon from "./DrawerIcons/workflowBuilder.svg";
import templateBuilderIcon from "./DrawerIcons/templateBuilder.svg";
import audienceIcon from "./DrawerIcons/audience.svg";
import settingsIcon from "./DrawerIcons/settings.svg";
import groupIcon from "./DrawerIcons/pie-chart.svg";
import analyticsIcon from "./DrawerIcons/activity.svg";

export const dataSubArray = [
  {
    id: "home",
    imgIcon: homeIcon,
    text: "Home",
    type: "menu",
    link: "/home",
  },
  {
    id: "messaging",
    imgIcon: messagingIcon,
    text: "Workflows",
    type: "group",
    children: [
      {
        id: "workflows",
        imgIcon: workflowBuilderIcon,
        text: "Workflow Builder",
        type: "menu",
        link: "/flow",
      },
      {
        id: "example-workflows",
        imgIcon: workflowBuilderIcon,
        text: "Example workflows",
        type: "menu",
        link: "/example-workflows",
      },
      {
        id: "automation-queue",
        imgIcon: workflowBuilderIcon,
        text: "Automation queue",
        type: "menu",
        link: "/leadstats/automation-runs",
      },
      {
        id: "train-workflow",
        imgIcon: workflowBuilderIcon,
        text: "Train Workflow",
        type: "menu",
        link: "/train-workflow",
      },
      {
        id: "ai-agents",
        imgIcon: workflowBuilderIcon,
        text: "AI Agents",
        type: "menu",
        link: "/ai-agents",
      },
      {
        id: "campaigns",
        imgIcon: templateBuilderIcon,
        text: "Message templates",
        type: "menu",
        link: "/templates",
      },
    ],
  },
  {
    id: "messages",
    imgIcon: inboxIcon,
    text: "Messages",
    type: "menu",
    link: "/messages",
  },
  {
    id: "analytics",
    imgIcon: analyticsIcon,
    text: "Analytics",
    type: "menu",
    link: "/analytics",
  },
  {
    id: "audience",
    imgIcon: audienceIcon,
    text: "Audience",
    type: "group",
    children: [
      {
        id: "users",
        imgIcon: audienceIcon,
        text: "Contacts",
        type: "menu",
        link: "/people",
      },
      {
        id: "groups",
        imgIcon: groupIcon,
        text: "Groups",
        type: "menu",
        link: "/group",
      },
    ],
  },
  // Removed for version 1 release
  // {
  //   id: "integrations",
  //   imgIcon: dataIcon,
  //   text: "Data",
  //   type: "group",
  //   children: [
  //     {
  //       id: "integrations",
  //       imgIcon: dataIcon,
  //       text: "Database import",
  //       type: "menu",
  //       link: "/integrations",
  //     },
  //     // {
  //     //   id: "analysis",
  //     //   imgIcon: Analysis(),
  //     //   text: "Analysis",
  //     //   type: "menu",
  //     //   link: "/analysis",
  //     // },
  //   ],
  // },
  {
    id: "settings",
    imgIcon: settingsIcon,
    text: "Settings",
    type: "menu",
    link: "/settings",
  },
];
